import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImage = (cardCode) => {
  if (!cardCode) return null;
  
  try {
    if (cardCode.length < 3) {
      return null;
    }
    
    return `/assets/img/cards/${cardCode}.png`;
  } catch (e) {
    return null;
  }
};

// Helper function to parse rdesc for aaa: "Amar#Even#Red#Under 7#2"
const parseRdesc = (rdesc) => {
  if (!rdesc) return {};
  
  const parts = rdesc.split('#');
  const winner = parts[0] || "";
  const oddEven = parts[1] || "";
  const color = parts[2] || "";
  const underOver = parts[3] || "";
  const cardValue = parts[4] || "";
  
  return {
    winner,
    oddEven,
    color,
    underOver,
    cardValue,
  };
};

const AAA = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  const cardImage = detailResult?.card ? getCardImage(detailResult.card) : null;
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || rdescData.winner || "";
  const winValue = detailResult?.win;
  
  // Map win value to player name
  let winnerName = winner;
  if (winValue === "1") winnerName = "Amar";
  else if (winValue === "2") winnerName = "Akbar";
  else if (winValue === "3") winnerName = "Anthony";

  return (
    <div className="row">
      <div className="col-12">
        <h6 className="text-right">
          <b>Round Id :</b> {roundId}
        </h6>
        <div className="text-center luckyseven-img">
          {cardImage && (
            <img src={cardImage} alt="Card" onError={(e) => {
              e.target.src = `/assets/img/cards/patti_back.png`;
            }} />
          )}
        </div>
        <div className="col-md-12 text-left">
          {winnerName && (
            <p className="m-b-0 m-t-20">
              <b>Winner:</b> {winnerName}
            </p>
          )}
          {rdescData.oddEven && (
            <p className="m-b-0">
              <b>Odd/Even:</b> {rdescData.oddEven}
            </p>
          )}
          {rdescData.color && (
            <p className="m-b-0">
              <b>Color:</b> {rdescData.color}
            </p>
          )}
          {rdescData.underOver && (
            <p className="m-b-0">
              <b>Under/Over:</b> {rdescData.underOver}
            </p>
          )}
          {rdescData.cardValue && (
            <p className="m-b-0">
              <b>Card:</b> {rdescData.cardValue}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AAA;

